export default {
  googletagmanager: "https://www.googletagmanager.com",
  mysph: "https://static.mysph.sph.com.sg",
  doubleclick: "https://securepubads.g.doubleclick.net",
  permutive: "https://5f876161-9740-4cc8-9b64-4585990b2690.edge.permutive.app",
  taboola: "https://cdn.taboola.com",
  adtag: "https://adtag.sphdigital.com",
};
